import { useState } from 'react';
import { FormControl, Stack, FormLabel } from '@chakra-ui/react';
import { Field } from 'formik';
import Input from '@/components/v4/Input';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';
import walkthroughIds from '../walkthroughIds';
import NumberField from 'components/forms/new/formikFormFields/NumberField';
import NameField from 'components/forms/new/formikFormFields/NameField';

const ApprovalCodeTrialDays = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.trialDays && touched.trialDays}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Trial Duration (days)
                </FormLabel>
                <Field
                    as={NameField}
                    id="trialDays"
                    name="trialDays"
                    type="number"
                    data-walkthroughid={walkthroughIds.createMode.ufTrialDurationInput}
                    validate={value => !value ? 'Please enter how many days your trial will last.' : undefined}
                    error={errors.trialDays}
                />

                {isHovered && (
                    <FieldToolTip
                        label="Enter the number of trial days."
                        ariaLabel="approval-code-trial-days-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ApprovalCodeTrialDays;